import { render, staticRenderFns } from "./media-popup.vue?vue&type=template&id=12b82596&scoped=true"
import script from "./media-popup.vue?vue&type=script&lang=js"
export * from "./media-popup.vue?vue&type=script&lang=js"
import style0 from "./media-popup.vue?vue&type=style&index=0&id=12b82596&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b82596",
  null
  
)

export default component.exports